import React, { useState } from 'react';
import FolderIcon from '../components/folderIcon';
const Fun = ({ theme, onBackClick,folders, onFolderClick, }) => {
    const [hoveredFolder, setHoveredFolder] = useState(null);
    return (
      <div className='fun'>
        <h3>What I do for fun</h3>
        <p>Aside from drawing and coding, I collect things and make OCs. 
            Here is just a catalogue of them.</p>
            <div className="folderChoices">
                {folders.map((folder) => (
                <div
                    key={folder.id}
                    onMouseEnter={() => setHoveredFolder(folder.id)}
                    onMouseLeave={() => setHoveredFolder(null)}
                >
                    <FolderIcon
                    theme={theme}
                    label={folder.label}
                    isHovered={hoveredFolder === folder.id}
                    onClick={() => onFolderClick(folder.id)}
                    />
                </div>
                ))}
            </div>
      </div>
    );
  };
  
  export default Fun;